import { ReactNode } from 'react';
import { ThemeProvider } from 'components/base/system/theme';
import { Box } from 'components/base/layout/Box';
import { CircularProgress } from 'components/atoms/CircularProgress';
import Button, { ButtonProps } from '@mui/material/Button';
import { createButtonTheme } from 'theme/button';

interface MuiButtonProps extends ButtonProps {
  children: ReactNode;
  loading?: boolean;
  startIcon?: ReactNode;
}

/**
 * @deprecated Use `Button` from "atoms/Button" instead.
 */
export default function MuiButton({
  children,
  loading,
  startIcon,
  ...rest
}: MuiButtonProps) {
  return (
    <ThemeProvider theme={createButtonTheme}>
      <Button
        {...rest}
        startIcon={
          <Box display="flex" alignItems="center" gap={0.2}>
            {startIcon}
            {loading && <CircularProgress size={20} color="inherit" />}
          </Box>
        }
      >
        {children}
      </Button>
    </ThemeProvider>
  );
}
